/********************************************************************************
 * Copyright (c) 2021 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
const ERROR = require('../errcodes');

module.exports = {
	// TYPES:
	ERROR: 'Error',
	WARNING: 'Warning',
	// INFO PROPERTIES:
	code: 'Error-Code',
	description: 'Description',
	paramIndex: 'Parameter',
	message: 'Details',
	messages: {
		[ERROR.LIMIT]: (values) =>
			`Function has a default limit of ${
				values.defaultLimit || '"unknown"'
			}. To prevent client overload only experienced user should increase this value.`
	},
	// EXCEL_ERRORS
	[ERROR.DIV0]: 'Division by zero is forbidden',
	[ERROR.NA]: 'Value not available',
	[ERROR.NAME]: 'Unknown formula or identifier',
	[ERROR.NUM]: 'Invalid number value',
	[ERROR.REF]: 'Invalid reference',
	[ERROR.VALUE]: 'Wrong value type',
	// ERROR CODES:
	[ERROR.ABORTED]: 'Aborted asynchronous function',
	[ERROR.ARGS]: 'Too few or too many arguments',
	[ERROR.CONNECTION]: 'Connection not available',
	[ERROR.DISCONNECTED]: 'Failed to connect',
	[ERROR.ERR]: 'Request or parsing error',
	[ERROR.EXECUTE]: 'Calculation mode of target Streamsheet is not set to EXECUTE',
	[ERROR.FUNC_EXEC]: 'Internal error',
	[ERROR.INVALID_LOOP_PATH]: 'Specified loop path is invalid',
	[ERROR.INVALID_PARAM]: 'Specified parameter is invalid',
	[ERROR.INVALID_PATH]: 'Specified path is invalid',
	[ERROR.INTERNAL]: 'Function for internal usage only',
	[ERROR.LIMIT]: 'Specified limit reached',
	[ERROR.NO_INTEGRATION]: 'Corresponding integration not available',
	[ERROR.NO_MACHINE]: 'Machine not available',
	[ERROR.NO_MACHINE_HTTP_SERVER]: 'Machine HTTP-Server setting not active',
	[ERROR.NO_MACHINE_OPCUA]: 'Machine OPCUA setting not active',
	[ERROR.NO_MSG]: 'Referenced message does not exist',
	[ERROR.NO_MSG_DATA]: 'No data a specified message path',
	[ERROR.NO_STREAMSHEET]: 'Referenced streamsheet does not exist',
	[ERROR.RANGE]: 'Invalid cell range',
	[ERROR.RESPONSE]: 'Error in request response',
	[ERROR.WAITING]: 'Waiting for a Streamsheet to finish'

	// [ERROR.NO_CONSUMER]: 'Unknown consumer used',
	// [ERROR.NO_PRODUCER]: 'Unknown producer used',
	// [ERROR.INVALID]: 'Function is deprecated',
	// '#NO_LIST': '',
	// '#NO_MSG_ID': '',
	// '#NO_OUTBOX': '',
	// '#NO_TOPIC': '',
	// '#NOT_AVAILABLE': '',
	// '#PROCESS_SHEET': '',
	// '#RANGE_INVALID': '',
	// '#SELF_REF': '',
	// '#SOURCE': '',
	// '#TARGET': '',
	// '#TOPIC_INVALID': '',
	// '#TYPE_PARAM': '',
};
